<template>
  <Dialog
    :visible="visible"
    modal
    :header="state?.header"
    :closable="!loading"
    :style="{ width: '28rem' }"
    @update:visible="handleCancel"
  >
    <p class="m-0">{{ state?.message }}</p>
    <template #footer>
      <Button
        label="Cancel"
        outlined
        :disabled="loading"
        @click="handleCancel"
      />
      <Button
        label="Yes"
        :severity="state?.danger ? 'danger' : undefined"
        :loading="loading"
        @click="handleAccept"
      />
    </template>
  </Dialog>
</template>

<script setup>
import Dialog from "primevue/dialog";
import Button from "primevue/button";
import { useConfirmAction } from "../composables/useConfirmAction";

const { visible, state, loading, handleAccept, handleCancel } =
  useConfirmAction();
</script>
